var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getFlagSharedShowFlightSearchResults === false
    ? _c(
        "div",
        {
          staticClass: "global-map-area mobile-section",
          attrs: { "data-stellar-background-ratio": "0.5" },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "table-wrapper hidden-table-sm" }, [
              _c(
                "div",
                { staticClass: "col-md-6 description section table-cell" },
                [
                  _c("h1", [_vm._v(_vm._s(_vm.title[_vm.getCurrentLocale]))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review clearfix" }, [
                    _vm._m(0),
                    _vm._v("\n                       "),
                    _c("label", [
                      _c("small", { staticClass: "white-color uppercase" }, [
                        _vm._v(_vm._s(_vm.rateus[_vm.getCurrentLocale])),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.info[_vm.getCurrentLocale]),
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2),
                ]
              ),
              _vm._v(" "),
              _vm._m(3),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "five-stars-container pull-left" }, [
      _c("div", {
        staticClass: "five-stars transparent-bg",
        staticStyle: { width: "100%" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://play.google.com/store/apps/details?id=com.sundair.Sundair&hl=de",
          target: "_new",
        },
      },
      [
        _c("img", {
          attrs: {
            src: "/res/images/storeicons/google-play-badge.png",
            width: "200",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://apps.apple.com/us/app/id1176981108",
          target: "_new",
        },
      },
      [
        _c("img", {
          attrs: {
            src: "/res/images/storeicons/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg",
            width: "165",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-6 image-wrapper table-cell hidden-sm" },
      [
        _c("img", {
          staticClass: "animated",
          attrs: {
            src: "/res/images/banner-sdr/mockup.svg",
            alt: "",
            "data-animation-type": "fadeInUp",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }